'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineQuotationEditor = require('./components/InlineQuotationEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineQuotationEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/inline-quotation-editor/index.js
// module id = 1519
// module chunks = 1